import { GameFullResponse } from "../../types/gameFull";
import {
  getActivePlateAppearance,
  getPitchesForPA,
  getWaitingPitch,
  WAITING_PITCH_ID,
} from "../../utils/plateAppearanceFeed";
import { FeedCard, FeedSectionLabel } from "./FeedCard";
import { HalfInningHeader } from "./HalfInningHeader";
import { PitchList, PitchListProps, WaitingPitchRow } from "./PitchRow";
import { PlateAppearanceHeader } from "./PlateAppearanceHeader";

type ActivePlateAppearanceProps = PitchListProps & {
  data: GameFullResponse;
  awayTeamColor: string;
  homeTeamColor: string;
  selectedPlateAppearanceId?: string;
  /** Opens the active at-bat editor (spec 2.3) */
  onMatchupClick?: (plateAppearanceId: string) => void;
};

export const ActivePlateAppearance = ({
  data,
  awayTeamColor,
  homeTeamColor,
  selectedPlateAppearanceId,
  onMatchupClick,
  ...pitchListProps
}: ActivePlateAppearanceProps) => {
  const plateAppearance = getActivePlateAppearance(data);
  if (!plateAppearance) return null;

  const { plateAppearanceId } = plateAppearance;
  const waitingPitch = getWaitingPitch(data);
  const { selectedActivityId, onSelectPitch } = pitchListProps;

  return (
    <section
      data-testid="plate-appearance-active-panel"
      data-plate-appearance-id={plateAppearanceId}
      data-inning={plateAppearance.inning}
      data-half={plateAppearance.isTopOfInning ? "top" : "bottom"}
      className="space-y-3"
    >
      <FeedSectionLabel>Active At-Bat</FeedSectionLabel>

      <FeedCard>
        <HalfInningHeader
          data-testid="plate-appearance-feed-half-inning-value"
          inning={plateAppearance.inning}
          isTopOfInning={plateAppearance.isTopOfInning}
        />
        <PlateAppearanceHeader
          data-testid="plate-appearance-header-button"
          data-plate-appearance-id={plateAppearanceId}
          pitcherName={plateAppearance.pitcher.playerName}
          hitterName={plateAppearance.hitter.playerName}
          pitcherId={plateAppearance.pitcher.playerId}
          hitterId={plateAppearance.hitter.playerId}
          isTopOfInning={plateAppearance.isTopOfInning}
          awayTeamColor={awayTeamColor}
          homeTeamColor={homeTeamColor}
          isSelected={selectedPlateAppearanceId === plateAppearanceId}
          onClick={
            onMatchupClick ? () => onMatchupClick(plateAppearanceId) : undefined
          }
        />
        {waitingPitch && (
          <WaitingPitchRow
            pitchNumber={waitingPitch.pitchNumber}
            isSelected={selectedActivityId === WAITING_PITCH_ID}
            onClick={
              onSelectPitch ? () => onSelectPitch(WAITING_PITCH_ID) : undefined
            }
          />
        )}
        <PitchList
          pitches={getPitchesForPA(data, plateAppearanceId)}
          {...pitchListProps}
        />
      </FeedCard>
    </section>
  );
};
